import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const Fire = (t0)=>{
    const $ = c(25);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t10;
    let t11;
    let t12;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M9.78157 17.8098C3.40656 17.8098 2.34953 11.9083 3.58664 9.65318C4.89485 7.26803 5.01203 9.90475 6.22688 10.3751C5.93625 9.7899 5.91477 7.65592 7.20188 6.2899C8.63235 4.77193 8.51086 2.82467 9.60813 2.38404C10.1999 2.14654 13.4437 4.96842 13.1562 9.211C14.0851 8.95631 14.7546 7.06412 15.4167 7.05318C16.3452 7.03756 17.582 8.69459 17.0503 11.8852C16.5523 14.8751 14.2843 17.8094 9.78157 17.8094V17.8098Z",
            fill: "url(#paint0_radial_4706_230421)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M5.59423 11.7077C6.02743 11.2901 7.61649 13.1159 7.54579 10.6014C7.48993 8.6108 9.18485 5.27798 10.2821 5.89165C10.8653 6.1854 10.6813 9.58501 11.9563 9.47134C11.4329 13.1835 13.4059 10.7862 14.1282 10.9436C15.0727 11.1475 14.2845 16.7795 9.60673 16.7795C5.96767 16.7795 4.9122 12.2792 5.59423 11.7081V11.7077Z",
            fill: "url(#paint1_radial_4706_230421)"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M10.2675 15.5386C7.79135 16.2456 7.01596 13.2808 7.61986 12.2667C8.03705 11.4698 8.09252 12.9316 8.94408 13.0214C8.42611 11.7093 9.30385 9.74172 9.85307 9.91945C10.2757 10.0562 9.72299 11.4585 11.2593 12.8386C12.0972 13.5913 11.7078 15.128 10.2675 15.539V15.5386Z",
            fill: "url(#paint2_radial_4706_230421)"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M4.47617 13.0777C5.05089 13.0777 5.5168 12.3682 5.5168 11.493C5.5168 10.6177 5.05089 9.9082 4.47617 9.9082C3.90145 9.9082 3.43555 10.6177 3.43555 11.493C3.43555 12.3682 3.90145 13.0777 4.47617 13.0777Z",
            fill: "url(#paint3_radial_4706_230421)"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M9.78157 17.8098C3.40656 17.8098 2.34953 11.9083 3.58664 9.65318C4.89485 7.26803 5.01203 9.90475 6.22688 10.3751C5.93625 9.7899 5.91477 7.65592 7.20188 6.2899C8.63235 4.77193 8.51086 2.82467 9.60813 2.38404C10.1999 2.14654 13.4437 4.96842 13.1562 9.211C14.0851 8.95631 14.7546 7.06412 15.4167 7.05318C16.3452 7.03756 17.582 8.69459 17.0503 11.8852C16.5523 14.8751 14.2843 17.8094 9.78157 17.8094V17.8098Z",
            fill: "url(#paint4_radial_4706_230421)"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M8.7415 8.62192C8.90175 7.76147 8.57363 6.97864 8.00863 6.87341C7.44362 6.76818 6.85568 7.38041 6.69543 8.24085C6.53518 9.1013 6.8633 9.88413 7.42831 9.98936C7.99331 10.0946 8.58125 9.48236 8.7415 8.62192Z",
            fill: "url(#paint5_radial_4706_230421)"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M9.78157 17.8098C3.40656 17.8098 2.34953 11.9083 3.58664 9.65318C4.89485 7.26803 5.01203 9.90475 6.22688 10.3751C5.93625 9.7899 5.91477 7.65592 7.20188 6.2899C8.63235 4.77193 8.51086 2.82467 9.60813 2.38404C10.1999 2.14654 13.4437 4.96842 13.1562 9.211C14.0851 8.95631 14.7546 7.06412 15.4167 7.05318C16.3452 7.03756 17.582 8.69459 17.0503 11.8852C16.5523 14.8751 14.2843 17.8094 9.78157 17.8094V17.8098Z",
            fill: "url(#paint6_radial_4706_230421)"
        });
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else {
        t10 = $[3];
        t11 = $[4];
        t12 = $[5];
        t6 = $[6];
        t7 = $[7];
        t8 = $[8];
        t9 = $[9];
    }
    let t13;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M9.78157 17.8098C3.40656 17.8098 2.34953 11.9083 3.58664 9.65318C4.89485 7.26803 5.01203 9.90475 6.22688 10.3751C5.93625 9.7899 5.91477 7.65592 7.20188 6.2899C8.63235 4.77193 8.51086 2.82467 9.60813 2.38404C10.1999 2.14654 13.4437 4.96842 13.1562 9.211C14.0851 8.95631 14.7546 7.06412 15.4167 7.05318C16.3452 7.03756 17.582 8.69459 17.0503 11.8852C16.5523 14.8751 14.2843 17.8094 9.78157 17.8094V17.8098Z",
            fill: "url(#paint7_radial_4706_230421)",
            style: {
                mixBlendMode: "lighten"
            }
        });
        $[10] = t13;
    } else t13 = $[10];
    let t14;
    let t15;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M9.78157 17.8098C3.40656 17.8098 2.34953 11.9083 3.58664 9.65318C4.89485 7.26803 5.01203 9.90475 6.22688 10.3751C5.93625 9.7899 5.91477 7.65592 7.20188 6.2899C8.63235 4.77193 8.51086 2.82467 9.60813 2.38404C10.1999 2.14654 13.4437 4.96842 13.1562 9.211C14.0851 8.95631 14.7546 7.06412 15.4167 7.05318C16.3452 7.03756 17.582 8.69459 17.0503 11.8852C16.5523 14.8751 14.2843 17.8094 9.78157 17.8094V17.8098Z",
            fill: "url(#paint8_radial_4706_230421)",
            fillOpacity: "0.8",
            style: {
                mixBlendMode: "multiply"
            }
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M15.5442 9.76593C15.9849 9.14007 16.0255 8.4098 15.635 8.13481C15.2444 7.85982 14.5706 8.14426 14.1299 8.77011C13.6893 9.39597 13.6486 10.1262 14.0392 10.4012C14.4297 10.6762 15.1035 10.3918 15.5442 9.76593Z",
            fill: "url(#paint9_radial_4706_230421)"
        });
        $[11] = t14;
        $[12] = t15;
    } else {
        t14 = $[11];
        t15 = $[12];
    }
    let t16;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.605 2.90514) scale(14.843 14.843)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF6B17"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.31",
                    stopColor: "#FF6B00"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.68",
                    stopColor: "#FF6E2A"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFAB03"
                })
            ]
        });
        $[13] = t16;
    } else t16 = $[13];
    let t17;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.4286 7.14087) scale(9.63984)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFB800"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.8",
                    stopColor: "#FFB900"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE600"
                })
            ]
        });
        $[14] = t17;
    } else t17 = $[14];
    let t18;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.56732 9.98024) rotate(-5.44) scale(5.7318 5.48789)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.04",
                    stopColor: "#FFCC02"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F8E68E"
                })
            ]
        });
        $[15] = t18;
    } else t18 = $[15];
    let t19;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(4.48891 11.5082) rotate(90) scale(1.56641 1.0025)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFCFAB",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "white",
                    stopOpacity: "0"
                })
            ]
        });
        $[16] = t19;
    } else t19 = $[16];
    let t20;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(5.72116 9.65314) rotate(55.8) scale(5.06914 2.88941)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.19",
                    stopColor: "#D83300",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FEB92F",
                    stopOpacity: "0"
                })
            ]
        });
        $[17] = t20;
    } else t20 = $[17];
    let t21;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.71991 8.44635) rotate(100.55) scale(1.56641 1.0025)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFCFAB",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "white",
                    stopOpacity: "0"
                })
            ]
        });
        $[18] = t21;
    } else t21 = $[18];
    let t22;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.6481 8.26943) rotate(118.21) scale(5.06914 2.88941)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.19",
                    stopColor: "#E73600",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FEB92F",
                    stopOpacity: "0"
                })
            ]
        });
        $[19] = t22;
    } else t22 = $[19];
    let t23;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint7_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.55617 7.20101) rotate(65.9486) scale(10.5189 11.7844)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.572917",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.914756",
                    stopColor: "#FF0099"
                })
            ]
        });
        $[20] = t23;
    } else t23 = $[20];
    let t24;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_4706_230421",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.1561 9.80472) rotate(-90) scale(7.71905 6.96274)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.782571",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF1D1D",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[21] = t24;
    } else t24 = $[21];
    let t25;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                /*#__PURE__*/ jsxs("radialGradient", {
                    id: "paint9_radial_4706_230421",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(14.8826 9.22591) rotate(125.15) scale(0.0169922 0.0103516)",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            stopColor: "#FFCFAB",
                            stopOpacity: "0.6"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "1",
                            stopColor: "white",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        });
        $[22] = t25;
    } else t25 = $[22];
    let t26;
    if ($[23] !== t5) {
        t26 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t25
            ]
        });
        $[23] = t5;
        $[24] = t26;
    } else t26 = $[24];
    return t26;
};
export { Fire };
